<template>
  <v-container
    fluid
    fill-height
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center 50px',
      backgroundRepeat: 'no-repeat',
    }"
  >
    <v-layout class="d-flex flex-column" style="height: 100%">
      <v-row class="fill-height" no-gutters>
        <v-col v-if="!expiredToken" :cols="12">
          <v-row>
            <v-col cols="12" md="2">
              <v-img
                :class="{
                  'portrait-img-left': $vuetify.breakpoint.smAndUp,
                  'portrait-img-center': $vuetify.breakpoint.smAndDown,
                }"
                contain
                :src="require('@/assets/VP_sin_fondo.png')"
              />
            </v-col>
            <v-col cols="12" md="8">
              <v-card class="pa-6" style="display: flex; flex-direction: column">
                <v-row class="d-flex justify-center" style="flex-grow: 1">
                  <v-col cols="11" class="pt-4 pb-0">
                    <v-row class="my-0 mx-6 d-flex justify-center">
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedMicrophone"
                          class="select-devices border-radius-16"
                          :items="audioDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select microphone *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                        />
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedSpeaker"
                          class="select-devices border-radius-16"
                          :items="outputDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select speakers *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                        />
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <v-select
                          v-model="selectedCamera"
                          class="select-devices border-radius-16"
                          :items="videoDevices"
                          item-text="label"
                          item-value="deviceId"
                          label="Select camera *"
                          solo
                          dense
                          :disabled="interviewStatus !== 'CREATED'"
                          @change="handleCameraChange"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center my-0">
                  <v-col cols="11" class="py-4 d-flex justify-center">
                    <div class="video-container-waiting-room">
                      <video
                        id="localVideo"
                        ref="localVideo"
                        class="call-player-video"
                        poster="img/no_camera_found_girado.png"
                        autoplay
                      ></video>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="11" class="py-0">
                    <p class="motivation-sentence-text">
                      Las estrellas se iluminan para que, algún día, cada uno encuentre la suya.
                      Bienvenido a tu propio viaje hacia la posición de "{{
                        interview.position.name
                      }}"
                    </p>
                  </v-col>
                </v-row>
                <!-- <v-row class="d-flex justify-center">
                  <v-col cols="10" class="py-0">
                    <p class="mb-0 position-title-interview-text">Position</p>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                  <v-col cols="10" class="py-0">
                    <p class="position-text">{{ interview.position.name }}</p>
                  </v-col>
                </v-row> -->
                <v-row class="mt-0">
                  <v-col cols="12" class="d-flex justify-center text-center pt-0">
                    <h2 class="join-interview-text">Ready to join?</h2>
                  </v-col>
                </v-row>
                <v-row class="d-flex justify-center mt-auto">
                  <v-col class="d-flex justify-center">
                    <v-btn
                      v-if="
                        interviewStatus === 'ANALYSING' ||
                        interviewStatus === 'ANALYSED' ||
                        interviewStatus === 'EXPIRED' ||
                        interviewStatus === 'ONGOING'
                      "
                      class="enter-btn"
                      disabled
                      @click="showVideoDialog = true"
                    >
                      Closed interview
                    </v-btn>
                    <v-btn
                      v-else-if="
                        selectedCamera === null ||
                        selectedMicrophone === null ||
                        selectedSpeaker === null ||
                        !acceptTerms
                      "
                      class="enter-btn"
                      disabled
                      @click="handleEnterClick"
                    >
                      Enter <v-icon class="ml-2">mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-btn v-else class="enter-btn" @click="handleEnterClick">
                      Enter <v-icon class="ml-2">mdi-chevron-right</v-icon>
                    </v-btn>
                    <v-tooltip right>
                      <template #activator="{ on }">
                        <v-btn icon class="ml-2" v-on="on">
                          <v-icon size="20" class="access-interview-info-btn"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>
                      <span
                        v-if="interviewStatus === 'ANALYSING' || interviewStatus === 'ANALYSED'"
                      >
                        The interview has been already completed.
                      </span>
                      <span v-else-if="interviewStatus === 'ONGOING'">
                        The interview is already underway.
                      </span>
                      <span v-else-if="interviewStatus === 'EXPIRED'">
                        The interview has expired.
                      </span>
                      <span
                        v-else-if="
                          selectedCamera === null ||
                          selectedMicrophone === null ||
                          selectedSpeaker === null
                        "
                      >
                        You cannot enter the interview until you select all hardware devices.
                      </span>
                      <span v-else-if="!acceptTerms">
                        You cannot enter the interview until you accept the terms and conditions
                      </span>
                      <span v-else>You can access to the interview.</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex justify-center text-center py-0">
                    <v-checkbox
                      v-if="!interview.hasAcceptedDataTreatment"
                      v-model="acceptTerms"
                      class="checkbox-terms-class my-0"
                      :label="'I accept the terms and conditions'"
                      :disabled="interviewStatus !== 'CREATED'"
                    />
                    <p v-else class="checkbox-terms-class mt-0 mb-4">
                      Terms and conditions were accepted on
                      {{ interview.AcceptDate | formatDate }}
                    </p>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="12" class="py-0">
                    <p class="terms-class mb-0">
                      We inform you that the data provided will be incorporated into the beonit
                      database, as the data controller/sub-controller, and will be processed for the
                      sole purpose of managing the relationship with the corresponding report. You
                      can find more information in our privacy policy at the following
                      <a href="https://www.beonit.es/privacidad" target="_blank" class="link-class"
                        >link</a
                      >.
                    </p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog v-model="showVideoDialog" max-width="800" min-height="800">
        <v-card>
          <v-card-title class="px-6">
            <h5 class="primary-color">Introduction video</h5>
          </v-card-title>
          <v-card-text class="my-4 pb-0 px-6">
            <video
              controls
              :src="getIntroVideoUrl(interview.introVideo)"
              width="100%"
              height="auto"
              style="transform: rotate(0deg)"
              autoplay
              @ended="endedVideo"
            ></video>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 mb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showVideoDialog = false"> Cancel </v-btn>
            <v-btn class="ok-modal" :disabled="!videoAccepted" @click="enterInterview">
              Enter
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import CandidatesDataService from '@/services/CandidatesDataService';
import InterviewsDataService from '@/services/InterviewsDataService';
import SocketioService from '@/services/socketioService.js';
import UserMediaController from '@/services/UserMedia.js';
import utils from '@/utils/utils.js';

export default {
  name: 'WaitingRoomCandidate',
  components: {},
  beforeRouteLeave(to, from, next) {
    if (this.selfUserStream) UserMediaController.stopStream(this.selfUserStream);
    this.selfUserStream = null;
    next();
  },
  data() {
    return {
      candidateName: '',
      candidates: [],
      microActivated: true,
      cameraActivated: true,
      selfUserStream: null,
      candidateId: null,
      interview: {
        name: 'prueba',
        description: 'Prueba',
        position: { name: 'prueba' },
        competencies: [{ name: 'prueba' }],
      },
      interviewStatus: null,
      reason: '',
      acceptTerms: false,
      videoDevices: [],
      audioDevices: [],
      outputDevices: [],
      selectedCamera: null,
      selectedMicrophone: null,
      selectedSpeaker: null,
      expiredToken: false,
      showVideoDialog: false,
      videoAccepted: false,
      token: null,
    };
  },
  watch: {
    acceptTerms() {
      if (this.acceptTerms && !this.interview.hasAcceptedDataTreatment) {
        InterviewsDataService.acceptTerms(this.interview.id, this.candidateId)
          .then(async (res) => {
            if (res.status === 200) {
              await InterviewsDataService.getInterviewInfo(this.token)
                .then(async (res) => {
                  if (res.status === 200) {
                    this.interview = res.data.data.interview;
                    this.interviewStatus = res.data.data.status;
                    if (
                      this.interview.AcceptDate !== null &&
                      this.interview.hasAcceptedDataTreatment
                    )
                      this.acceptTerms = true;
                  }
                })
                .catch((err) => {
                  console.error(err);
                  if (err.response.data.error === 'TOKEN_EXPIRED') this.expiredToken = true;
                  else this.expiredToken = false;
                });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
  created() {},
  async mounted() {
    if (this.$route.query.token === undefined) this.$router.push('/error');
    else {
      this.token = this.$route.query.token;

      await this.getDevices();
      await InterviewsDataService.getInterviewInfo(this.token)
        .then(async (res) => {
          if (res.status === 200) {
            this.interview = res.data.data.interview;
            this.interviewStatus = res.data.data.status;
            if (this.interview.AcceptDate !== null && this.interview.hasAcceptedDataTreatment)
              this.acceptTerms = true;
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response.data.error === 'TOKEN_EXPIRED') this.expiredToken = true;
          else this.expiredToken = false;
        });

      if (!this.expiredToken) {
        await CandidatesDataService.findAllInfoFromCandidate(this.token).then(async (res) => {
          if (res.status === 200) {
            this.candidateName = res.data.data.candidateUsername;
            this.candidateId = res.data.data.candidateId;

            Vue.prototype.$socket = SocketioService.setupSocketConnection(
              this.candidateId,
              null,
              false
            );
          }
        });

        UserMediaController.getUserMedia(
          function (stream) {
            if (!stream) {
              stream = UserMediaController.getPlaceholderStream();
            }

            if (stream !== null) {
              UserMediaController.setMediaStreamVideoEnabled(stream, this.cameraActivated);
              UserMediaController.setMediaStreamAudioEnabled(stream, this.microActivated);

              this.selfUserStream = stream;
            } else {
              console.error('Error getting user media');
            }
          }.bind(this)
        );
      }
    }
  },
  beforeUnmount() {},
  methods: {
    getIntroVideoUrl(introVideo) {
      if (!introVideo) return '';
      return `${utils.config.publicBucketURL}/${introVideo}`;
    },
    handleEnterClick() {
      if (this.interview.introVideo) {
        this.showVideoDialog = true;
      } else {
        this.enterInterview();
      }
    },
    endedVideo() {
      this.videoAccepted = true;
    },
    async getDevices() {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

        const devices = await navigator.mediaDevices.enumerateDevices();
        this.videoDevices = devices.filter((device) => device.kind === 'videoinput');
        this.audioDevices = devices.filter((device) => device.kind === 'audioinput');
        this.outputDevices = devices.filter((device) => device.kind === 'audiooutput');
      } catch (err) {
        console.error('Error al obtener dispositivos:', err);
      }
    },
    async setCameraStream(deviceId) {
      if (this.selfUserStream) {
        this.selfUserStream.getTracks().forEach((track) => track.stop());
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: deviceId ? { deviceId: { ideal: deviceId } } : true,
        });
        this.selfUserStream = stream;

        const videoElement = this.$refs.localVideo;
        videoElement.srcObject = stream;
      } catch (error) {
        console.error('Error accessing camera:', error);
      }
    },
    async handleCameraChange() {
      await this.setCameraStream(this.selectedCamera);
    },
    async enterInterview() {
      await InterviewsDataService.updateInterviewStatus(this.interview.id).then(() => {
        this.$router.push({
          name: 'avatar interview',
          params: {
            interview: this.interview,
            video: this.cameraActivated,
            audio: this.microActivated,
            candidateName: this.candidateName,
            redirectParams: this.$route.query,
            candidateId: this.candidateId,
            camera: this.selectedCamera,
            microphone: this.selectedMicrophone,
            speaker: this.selectedSpeaker,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.v-container {
  height: 100vh;
}

.call-player-video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 16px !important;
  z-index: 1 !important;
}
</style>
